import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaEnvelope } from 'react-icons/fa';
import axios from 'axios';
import CustomHeader from '../../components/layout/CustomHeader';
import CustomFooter from '../../components/layout/CustomFooter';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }
    
    try {
      setIsLoading(true);
      const response = await axios.post('/api/v1/auth/forgotpassword', { email });
      setEmailSent(true);
      toast.success(response.data.message || 'Password reset email sent successfully');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to send reset email';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <CustomHeader activePage="login" />
      
      <div className="flex items-center justify-center min-h-screen px-4 py-24 pt-32">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-primary font-solway">Forgot Password</h2>
            <p className="text-gray-600 mt-2">
              {emailSent
                ? 'Check your email for reset instructions'
                : 'Enter your email to receive a password reset link'}
            </p>
          </div>

          {!emailSent ? (
            <form onSubmit={handleSubmit}>
              {/* Email Field */}
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FaEnvelope className="text-gray-400" />
                  </div>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-field pl-10"
                    placeholder="Enter your registered email"
                    required
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full btn-primary py-3 flex justify-center items-center mt-6"
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  'Send Reset Link'
                )}
              </button>
            </form>
          ) : (
            <div className="text-center p-4 bg-green-50 container-rounded-lg mb-6">
              <p className="text-green-700">
                We've sent a password reset link to <strong>{email}</strong>. Please check your inbox and follow the instructions to reset your password.
              </p>
              <p className="text-green-700 mt-2">
                If you don't see the email, please check your spam folder.
              </p>
            </div>
          )}

          {/* Back to Login */}
          <div className="text-center mt-6">
            <Link to="/login" className="text-primary font-medium hover:underline">
              Back to Login
            </Link>
          </div>

          {/* Back to Home */}
          <div className="text-center mt-4">
            <Link to="/" className="text-sm text-gray-500 hover:text-primary">
              &larr; Back to Home
            </Link>
          </div>
        </div>
      </div>

      <CustomFooter />
    </>
  );
};

export default ForgotPassword;